import moment from 'moment';

export default class AssessmentSimulationSimple {
  id: string;

  assignmentId: string;

  assignmentName: string;

  levelName: string;

  levelId: string;

  createdDate: string;

  loadingViewSimulation: boolean = false;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.assignmentId = obj.assignmentId || '';
    this.assignmentName = obj.assignmentName || '';
    this.levelName = obj.levelName || '';
    this.levelId = obj.levelId || '';
    this.createdDate = obj.createdDate || '';
  }

  get createdDateFormatted(): string {
    return moment(this.createdDate).format('DD/MM/YYYY HH:mm');
  }
}
